import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import { PROMETHEAN_NEUTRAL_WHITE, PROMETHEAN_TEXT } from '../../../styles/colors/colors';
import { PROMETHEAN_TYPOGRAPHY_BODY, PROMETHEAN_TYPOGRAPHY_SMALL_TEXT } from '../../../styles/typography/typography';
export var StyledResultsPerPage = styled('div')(function () {
  return {
    '&.EmbersTable-ResultsPerPage-root': {
      display: 'flex',
      alignItems: 'center',
      '.EmbersTable-ResultsPerPage-title': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SMALL_TEXT), {}, {
        color: PROMETHEAN_TEXT,
        whiteSpace: 'nowrap',
        marginRight: 8
      }),
      '.EmbersTable-ResultsPerPage-select': {
        '.MuiOutlinedInput-root': {
          width: 61,
          height: 32,
          backgroundColor: PROMETHEAN_NEUTRAL_WHITE,
          padding: '4px 36px 4px 8px',
          '.MuiOutlinedInput-input': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_BODY), {}, {
            padding: '0 !important'
          }),
          '.MuiAutocomplete-endAdornment': {
            top: 'calc(50% - 14px)'
          }
        }
      }
    }
  };
});